import Highcharts from 'highcharts'
import React, { useEffect } from 'react'
import accuracy from '../../assets/accuracy.svg'
import Card from '../Card/Card'
import { colorName, subjectName } from '../OverAllScore/OverAllScore'
import './OverAllAccuracy.css'

const OverAllAcuracy = (props) => {
    let sections = []
    let colors = []
    useEffect(() => {
        props.data?.analytics?.sections?.map((item) => {
            let col = colorName(item)
            sections.push(
                "<b style='color: " + col + "'>" + subjectName(item) + '</b>',
            )
            colors.push(col)
        })
        Highcharts.chart('overallaccuracy', {
            chart: {
                type: 'bar',
                height: props.width - 40,
                width: props.width,
            },
            colors: colors,
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: sections,
                title: {
                    text: null,
                },
            },
            yAxis: {
                min: 0,
                max: 100,
                lineColor: '#999',
                lineWidth: 0.5,
                title: {
                    text: '',
                    align: 'high',
                },
                labels: {
                    formatter: function () {
                        return this.value + '%'
                    },
                },
            },
            tooltip: {
                valueSuffix: ' percentage',
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        color: 'black',
                        formatter: function (val) {
                            if (this.y >= 90) {
                                val.y = -15
                            }
                            return this.y + '%'
                        },
                    },
                },
                series: {
                    dataLabels: {
                        //y:-15
                    },
                },
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    colorByPoint: true,
                    data: props.data.analytics.sectionWiseAccuracy,
                    showInLegend: false,
                    pointWidth: 13,
                },
            ],
        })
    }, [props.data?.analytics?.sections])

    return (
        <div className="overallaccuracy">
            <Card>
                <div className="card-header">
                    <div className="card-overallaccuracy-text">
                        <img src={accuracy} alt="accuracy" />
                        &nbsp;&nbsp;Overall Accuracy
                    </div>
                    <div className="card-overallaccuracy">
                        <span className="card-overallaccuracy-marks">
                            {props.data.analytics.overallAccuracy}%
                        </span>
                    </div>
                </div>
                <div id="overallaccuracy"></div>
            </Card>
        </div>
    )
}

export default OverAllAcuracy
